var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"go-back"},[_c('v-btn',{attrs:{"color":"secondary","large":"","rounded":"","elevation":"0"},on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-left")]),_vm._v("\n        Voltar")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }